import type { TourDefinition } from './types';
import { ADMIN_TOUR_STEPS } from './AdminTour/types';
import { TEMPLATES_TOUR_STEPS } from './TemplatesTour/types';
import { ASSIGNMENTS_TOUR_STEPS } from './AssignmentsTour/types';
import { TAGS_TOUR_STEPS } from './TagsTour/types';
import { REGISTRATION_TOUR_STEPS } from './RegistrationTour/types';
import { EO_GUARDRAILS_TOUR_STEPS } from './EoGuardrailsTour/types';
import { LOGGING_TOUR_STEPS } from './LoggingTour/types';
import { WHY_VOLEY_TOUR_STEPS } from './WhyVoleyTour/types';
import { CONTACT_MANAGEMENT_TOUR_STEPS } from './ContactManagementTour/types';
import { WHY_SMS_TOUR_STEPS } from './WhySmsTour/types';
import { CONV_MGMT_TOUR_STEPS } from './ConversationMgmtTour/types';
import { CRM_CONNECT_TOUR_STEPS } from './CrmConnectTour/types';
import { AMS_CONNECT_TOUR_STEPS } from './AmsConnectTour/types';

/** All registered tours available in the app */
export const TOUR_REGISTRY: TourDefinition[] = [
  { id: 'why-voley', steps: WHY_VOLEY_TOUR_STEPS },
  { id: 'admin', steps: ADMIN_TOUR_STEPS },
  { id: 'templates', steps: TEMPLATES_TOUR_STEPS },
  { id: 'assignments', steps: ASSIGNMENTS_TOUR_STEPS },
  { id: 'tags', steps: TAGS_TOUR_STEPS },
  { id: 'registration', steps: REGISTRATION_TOUR_STEPS },
  { id: 'eo-guardrails', steps: EO_GUARDRAILS_TOUR_STEPS },
  { id: 'logging', steps: LOGGING_TOUR_STEPS },
  { id: 'contact-management', steps: CONTACT_MANAGEMENT_TOUR_STEPS },
  { id: 'why-sms', steps: WHY_SMS_TOUR_STEPS },
  { id: 'conversation-management-tour', steps: CONV_MGMT_TOUR_STEPS },
  { id: 'crm-connect', steps: CRM_CONNECT_TOUR_STEPS },
  { id: 'ams-connect', steps: AMS_CONNECT_TOUR_STEPS },
];
